const light = Object.freeze({
    primary: '#3c3c3c',
    secondary: '#c2b393',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    logoFontColor: '#0094D2',
    logoColor: '#878786',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#c2b393',
    secondary: '#3c3c3c',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoFontColor: '#FFFFFF',
    logoColor: '#c2b393',
    error: '#F99C9D',
    info: '#90C9F9',
    success: '#A5D6A7',
    warning: '#FFCB7F',
})

const props = Object.freeze({
    headerLogoWidth: 55,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

